import { UserAddOutlined, SafetyOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";

import EmailSVG from "./EmailSVG";
import { emptyGeneratedHtml } from "../../actionCreator/webToLeadActionCreater";
import { getUserInfo } from "../../utils/utils";

const SettingsSidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { role, permissions } = getUserInfo();
  const isWebToLeadView = permissions?.["Web To Leads"]?.find(
    (d) => d?.name === "View"
  );
  const isEmailSetupView = permissions?.["Email Setup"]?.find(
    (d) => d?.name === "View"
  );

  return (
    <div className="fw-bold sidebar">
      <div className="heading24px" style={{ paddingLeft: 10 }}>
        Settings
      </div>
      {role === "ADMIN" && (
        <div
          className={`menu-item heading13px d-flex align-items-center mt20 cursor-pointer ${location.pathname.includes("user-management") && "active-link"}`}
          style={{ gap: 10 }}
          onClick={() => navigate("/settings/user-management")}
        >
          <SafetyOutlined className="heading15px" />
          User Management & Access Control
        </div>
      )}
      {isWebToLeadView && (
        <div
          className={`menu-item heading13px d-flex align-items-center mt10 cursor-pointer ${location.pathname.includes("web-to-lead") && "active-link"}`}
          style={{ gap: 10 }}
          onClick={() => {
            navigate("/settings/web-to-lead");
            dispatch(emptyGeneratedHtml());
          }}
        >
          <UserAddOutlined className="heading15px" />
          Web to Leads
        </div>
      )}
      {isEmailSetupView && (
        <div
          className={`menu-item heading13px d-flex align-items-center mt10 cursor-pointer ${location.pathname.includes("email-setup") && "active-link"}`}
          style={{ gap: 10 }}
          onClick={() => navigate("/settings/email-setup")}
        >
          <EmailSVG />
          Email Setup
        </div>
      )}
    </div>
  );
};

export default SettingsSidebar;
